import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Switch from 'flarum/common/components/Switch';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
const endpoint = () => app.forum.attribute('apiUrl') + '/voucha-newsletter/me';
export default class NewsletterSettings extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.saving = false;
    this.saved = false;
    this.error = null;
    this.data = null;
    app.request({
      method: 'GET',
      url: endpoint()
    }).then(data => {
      this.data = data;
    }).catch(() => {
      this.error = 'Could not load your newsletter settings. Please refresh the page.';
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    if (this.loading) {
      return m(LoadingIndicator, {
        display: "inline",
        size: "small"
      });
    }
    if (this.error) {
      return m("p", {
        className: "helpText"
      }, this.error);
    }
    const data = this.data;
    if (data.excluded) {
      return m("p", {
        className: "helpText"
      }, "Newsletters aren't available for this account's email address.");
    }
    return m("div", {
      className: "VouchaNewsletterSettings"
    }, m(Switch, {
      state: data.subscribed,
      loading: this.saving,
      onchange: value => this.save(value, this.selectedIds())
    }, "Email me Voucha newsletters"), data.subscribed ? m("div", {
      className: "VouchaNewsletterSettings-categories"
    }, m("p", {
      className: "helpText"
    }, "Choose what you'd like to receive at ", data.email, ":"), data.categories.map(category => m(Switch, {
      className: "VouchaNewsletterSettings-category",
      state: category.selected,
      disabled: this.saving,
      onchange: value => this.toggleCategory(category.id, value)
    }, m("div", {
      className: "VouchaNewsletterSettings-label"
    }, m("span", {
      className: "VouchaNewsletterSettings-name"
    }, category.name), category.description ? m("span", {
      className: "VouchaNewsletterSettings-desc"
    }, category.description) : null)))) : null, this.saved && !this.saving ? m("p", {
      className: "helpText VouchaNewsletterSettings-saved"
    }, "Saved.") : null);
  }
  selectedIds() {
    return this.data.categories.filter(c => c.selected).map(c => c.id);
  }
  toggleCategory(id, value) {
    const ids = this.data.categories.filter(c => c.id === id ? value : c.selected).map(c => c.id);

    // Unticking the last category means "no newsletters"
    this.save(ids.length > 0, ids);
  }
  save(subscribed, categoryIds) {
    this.saving = true;
    this.saved = false;
    app.request({
      method: 'POST',
      url: endpoint(),
      body: {
        subscribed,
        categoryIds
      }
    }).then(data => {
      this.data = data;
      this.saved = true;
    }).catch(() => {
      app.alerts.show({
        type: 'error'
      }, 'Could not save your newsletter settings. Please try again.');
    }).finally(() => {
      this.saving = false;
      m.redraw();
    });
  }
}
flarum.reg.add('voucha-newsletter', 'forum/components/NewsletterSettings', NewsletterSettings);